import { DestinationForm } from "@/pages/carrier-delivery-proposal-create/ui/preview/forms/destinations-form/destination-form";
import {} from "@/shared/lib/datetime";
import { Stack } from "@mui/material";
import type {} from "type-fest";
import { DeliveryProposalFormLayout } from "../../../../../../widgets/delivery-proposal-form-layout";
import type { AdminDeliveryProposalCreatePageProps } from "../../../../model";

export const DestinationsForm = (props: {
  draftOfferCargo: AdminDeliveryProposalCreatePageProps["draftOfferCargo"];
  previewValues: NonNullable<
    AdminDeliveryProposalCreatePageProps["previewValues"]
  >;
}) => {
  const { draftOfferCargo, previewValues } = props;
  const draftOfferCargoData = draftOfferCargo.data;
  const destinations = draftOfferCargo.data?.destinations;

  return (
    <DeliveryProposalFormLayout
      title={"配送スケジュール・ルート"}
      isLoading={!draftOfferCargo.data}
    >
      {draftOfferCargoData && destinations && (
        <Stack spacing={3} alignItems="stretch">
          <DestinationForm
            taskContent="loading"
            draftOfferCargo={draftOfferCargoData}
            draftOfferCargoDestination={destinations[0]}
            previewDestinationValues={previewValues.loadingDestination}
          />
          {destinations.slice(1, -1).map((destination, index) => (
            <DestinationForm
              key={JSON.stringify(destination)}
              taskContent="transit"
              draftOfferCargo={draftOfferCargoData}
              draftOfferCargoDestination={destination}
              previewDestinationValues={
                previewValues.transitDestinations[index]
              }
            />
          ))}
          <DestinationForm
            taskContent="unloading"
            draftOfferCargo={draftOfferCargoData}
            draftOfferCargoDestination={destinations[destinations.length - 1]}
            previewDestinationValues={previewValues?.unloadingDestination}
          />
        </Stack>
      )}
    </DeliveryProposalFormLayout>
  );
};
